import React, { useState, useEffect } from "react";
import axios from "axios";
import { baseurl } from "../../../Baseurl";
import Swal from "sweetalert2";
import { Edit, Save } from "react-feather";
import AdminSidebar from "../../../component/AdminComp/AdminSidebar";
import AdminTopbar from "../../../component/AdminComp/AdminTopbar";
import AddSubcategory from "./AddSubcategory";
import { useParams, useNavigate } from "react-router-dom";


const EditSubcategory = () => {
    const { id, categoryId, subCategoryName } = useParams(); 
    const navigate = useNavigate();
    
    // console.log(id, categoryId, subCategoryName); 


    const [formData, setFormData] = useState({
      subCategoryName: subCategoryName,
      categoryId: categoryId,
    });
    const [categories, setCategories] = useState([]);
  
    // Fetch categories on component mount
    useEffect(() => {
      const fetchCategories = async () => {
        try {
          const response = await axios.get(`${baseurl}getAllCategories`);
          setCategories(response.data.data); // Assuming the API returns an array of categories
        } catch (error) {
          console.error("Error fetching categories:", error);
        }
      };
      fetchCategories();
    }, []);
  
    // Handle form submission for updating subcategory
    const handleSubmit = async (e) => {
      e.preventDefault();
      console.log("Data being sent:", {
        id,
        subCategoryName: formData.subCategoryName,
        categoryId: formData.categoryId,
      });
  
      try {
        const response = await axios.put(`${baseurl}updateSubcategory`, {
          id,
          subCategoryName: formData.subCategoryName,
          categoryId: formData.categoryId,
        });
        if (response.status === 200) {
          Swal.fire("Success", "Subcategory updated successfully", "success");
          navigate(-1);

        //   window.location.reload(); 
        }
      } catch (error) {
        console.error("Error updating subcategory:", error);
        Swal.fire("Error", "There was an error updating the subcategory", "error");
      }
    };
  
    return (
      
        <>
        <div className="App" style={{ display: "flex" }}>
      <AdminSidebar/>
      {/* Content area */}
      <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
        <AdminTopbar/>
        <div className="container-fluid">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h4 className="text-start">Edit Sub Category</h4>
            <div>
              <AddSubcategory/>
            </div>
          </div>

          <div className="text-start">
            <div className="row p-2">
                <div className="col-md-6 bg-white ">
                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label className="form-label">Category</label>
                    <select
                      className="form-control"
                      value={formData.categoryId}
                      onChange={(e) =>
                        setFormData({ ...formData, categoryId: e.target.value })
                      }
                      required
                    >
                      <option value="">Select Category</option>
                      {categories.map((category) => (
                        <option key={category.id} value={category.id}>
                          {category.category_name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Subcategory Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={formData.subCategoryName}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          subCategoryName: e.target.value,
                        })
                      }
                      required
                    />
                  </div>
                  <div className=" mb-3 text-end">
                    <button type="submit" className="btn btn-primary">
                      <Save size={15} /> &nbsp; Save Changes
                    </button>
                  </div>
                </form>
                </div>
            </div>
                
              </div>


        </div>
      </div>
    </div>
             
              </>
    );
  };
  
  export default EditSubcategory;
  